type Props = {
    label: string;
};

export const DateSeparator = ({ label }: Props) => (
    <div className="my-3 flex items-center gap-3 px-4">
        <span className="h-px flex-1 bg-outline-light" />
        <span className="rounded-full bg-grey-light px-3 py-1 text-xs text-grey">{label}</span>
        <span className="h-px flex-1 bg-outline-light" />
    </div>
);
